module.exports = __webpack_public_path__ + "img/thriller.7bf961a9.svg";